import React, {FC, useState} from 'react'
import {isNullOrEmpty} from '../../../../services/Utils'
import { PrivilegeAdd, UpdateMPriv} from '../../../../services/main'
import {toast} from 'react-toastify'
import {
  PrivilegeAddReq,
  PrivilegeGroupAddReq,
} from '../../../../services/Request'
interface IProps {
  t: any
  item: any
  onAddSuccess: any
}
const PrivCreate: FC<IProps> = ({t, item, onAddSuccess}) => {
  const [privName, setPrivName] = useState(isNullOrEmpty(item) ? '' : item.PrivName)
  const [privNo, setPrivNo] = useState(isNullOrEmpty(item) ? '' : item.PrivNo)
  const [count, setCount] = useState(0)
  const [loading, setLaoding] = useState(false)
  const [validate, setValidate] = useState<any>([])

  interface Privilege {
    privName: string;
    privNo: string;
  }
  
  interface PrivilegeAddReq {
    mPriv: Privilege;
  }
  
  const save = () => {
    var res = validateFunc()
    if (res.retType === 0) {
      setLaoding(true)
      const reqq: PrivilegeAddReq = {
        mPriv: {
          privName: privName,
          privNo: privNo
        }
      };
      PrivilegeAdd(reqq, onSuccess, onFailed, 'POST')
    }
  }

  const onSuccess = () => {
    setLaoding(false)
    onAddSuccess(t('common:successCreate'))
  }

  const onFailed = (err: string) => {
    setLaoding(false)
    return toast.error(err)
  }

  const update = () => {
    var res = validateFunc()
    if (res.retType === 0) {
      setLaoding(true)
      var req = PrivilegeAddReq
      
      UpdateMPriv(req, onUpdateSuccess, onFailed, 'PUT')
    }
  }

  const onUpdateSuccess = () => {
    setLaoding(false)
    onAddSuccess(t('common:successUpdate'))
  }

  const validateFunc = () => {
    var res = {retType: 0}

    if (isNullOrEmpty(privNo)) {
      res.retType = 1
      validate['privNo'] = true
    }

    if (isNullOrEmpty(privName)) {
      res.retType = 1
      validate['privName'] = true
    }

    setValidate(validate)
    setCount(count + 1)
    return res
  }

  const validateChange = (id: string, e: any) => {
    var val = ''
    e.target === undefined ? (val = e) : (val = e.target.value)
    if (val !== '') {
      validate[id] = false
    } else {
      validate[id] = true
    }
    setValidate(validate)
    setCount(count + 1)
  }

  return (
    <div>
      <div className='scroll-x mx-5 mx-xl-10 pt-10 pb-10 w-500px'>
        <span style={{visibility: 'hidden'}}>{count}</span>
        <div className='text-center mb-13'>
          <h1 className='mb-3'>{t('common:privilege.add')}</h1>
        </div>
        <div className='mb-8'>
          <input
            className='form-control form-control-solid'
            placeholder={t('common:privilege.PrivNo')}
            onChange={(e) => {
              setPrivNo(e.target.value)
              validateChange('privNo', e)
            }}
            disabled={!isNullOrEmpty(item)}
            value={privNo}
          ></input>
          {validate['privNo'] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{t('common:validInsert')}</div>
            </div>
          ) : null}
        </div>

        <div className='mb-8'>
          <input
            className='form-control form-control-solid'
            placeholder={t('common:privilege.PrivName')}
            onChange={(e) => {
              setPrivName(e.target.value)
              validateChange('privName', e)
            }}
            value={privName}
          ></input>
          {validate['privName'] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{t('common:validInsert')}</div>
            </div>
          ) : null}
        </div>
        <div className='pt-10' style={{textAlign: 'right'}}>
          <button
            className='btn btn-primary align-self-center'
            onClick={isNullOrEmpty(item) ? save : update}
            disabled={loading}
          >
            {loading ? t('common:loading') : t('common:save')}
          </button>
        </div>
      </div>
    </div>
  )
}

export {PrivCreate}
